import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import testIds from "constants/testIds";
import { formatPriceV2 } from "helpers/commonHelpers";
import "./components/costDetails.scss";
import CostCharges from "./components/CostCharges";
import CostConversionRates from "./components/CostConversionRates";
import PostBookingConstDetails from "./components/PostBookingCostDetails";

interface CostDetailDialogProps {
  costDetailsData: any;
  quotationStatus: string;
}

const CostDetailDialog = function ({ costDetailsData, quotationStatus }: CostDetailDialogProps) {
  return (
    <section>
      <table
        className="w-100"
        style={{ tableLayout: "fixed" }}
        data-testid={testIds.SHIPMENT_DASHBOARD_QUOTE_CHARGES_TABLE}
      >
        {quotationStatus !== "lost" && <PostBookingConstDetails costDetailsData={costDetailsData} />}
        <thead style={{ marginBottom: "12px" }}>
          <tr className="cost-details__header font-b4 text-secondary">
            <td className="cost-details__header-charge">
              <FormattedMessage id="quote-request.charges" defaultMessage="Charges" />
            </td>
            <td className="text-right cost-details__header-charge">
              <FormattedMessage id="general.quoted" defaultMessage="Quoted" />
            </td>
            <td className="cost-details__header-charge text-right">
              <FormattedMessage id="general.quoted" defaultMessage="Quoted" /> (
              {costDetailsData?.total_quoted_amount_currency})
            </td>
          </tr>
        </thead>
        <tbody>
          <CostCharges costDetailsData={costDetailsData} />
          <tr style={{ height: "35px" }} className="font-weight-bold">
            <td className="cost-details__charge">
              <FormattedMessage id="quote-request-detail.total" defaultMessage="Total" />
            </td>
            <td className="cost-details__charge text-right">
              {formatPriceV2(costDetailsData?.total_quoted_amount_lsp)} {costDetailsData?.lsp_currency}
            </td>
            <td className="cost-details__charge text-right">
              {formatPriceV2(costDetailsData?.total_quoted_amount)} {costDetailsData?.total_quoted_amount_currency}
            </td>
          </tr>
        </tbody>
      </table>
      <CostConversionRates costDetailsData={costDetailsData} />
    </section>
  );
};

CostDetailDialog.propTypes = {
  costDetailsData: PropTypes.instanceOf(Object).isRequired,
};

export default CostDetailDialog;
